import { PageWithTitle } from './PageWithTitle';
import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { type SerializedError } from '@reduxjs/toolkit';
import { ShowError } from 'src/shared/components/ShowError';

type PageWithTitleErrorProps = {
  error: FetchBaseQueryError | SerializedError | Error | undefined;
  title: string;
};

export const PageWithTitleError = ({ title, error }: PageWithTitleErrorProps) => {
  return (
    <PageWithTitle title={title}>
      <ShowError error={error} />
    </PageWithTitle>
  );
};
